// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-collection-header,
.card-collection-content {
  width: 300px;
}

.card-collection-header {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px;
  align-items: center;

  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px -4px 12px rgba(20, 43, 79, 0.16);
  border-radius: 4px;
  cursor: pointer;
}

.active {
  border-radius: 0px 0px 4px 4px;
}

.card-collection-content {
  height: 200px;
  overflow: auto;
  padding: 0;

  background: rgba(255, 255, 255, 0.88);
  border-radius: 4px 4px 0px 0px;
}

.card-collection-item {
  padding: 5px 16px;
  cursor: pointer;
}

.card-collection-item:hover {
    background-color: #f6f9fb;
  }

@media screen and (min-width: 1530px) {
  .card-collection {
    position: fixed;
    left: 830px;
    bottom: 40px;
  }

    .card-collection_content {
      bottom: 40px;
    }
}

@media screen and (max-width: 1530px) {
  .card-collection {
    position: relative;
    margin-bottom: 10px;
    z-index: 1;
  }

    .card-collection-header,
    .card-collection-content {
      margin-left: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Module/CardCollection/style.scss"],"names":[],"mappings":"AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;EAEnB,qCAAqC;EACrC,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;;EAEV,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AAKjB;;AAHE;IACE,yBAA8B;EAChC;;AAGF;EACE;IACE,eAAe;IACf,WAAW;IACX,YAAY;EAKd;;IAHE;MACE,YAAY;IACd;AAEJ;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;EAMZ;;IAJE;;MAEE,iBAAiB;IACnB;AAEJ","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.card-collection-header,\n.card-collection-content {\n  width: 300px;\n}\n\n.card-collection-header {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0px -4px 12px rgba(20, 43, 79, 0.16);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.active {\n  border-radius: 0px 0px 4px 4px;\n}\n\n.card-collection-content {\n  height: 200px;\n  overflow: auto;\n  padding: 0;\n\n  background: rgba(255, 255, 255, 0.88);\n  border-radius: 4px 4px 0px 0px;\n}\n\n.card-collection-item {\n  padding: 5px 16px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: $white-light;\n  }\n}\n\n@media screen and (min-width: 1530px) {\n  .card-collection {\n    position: fixed;\n    left: 830px;\n    bottom: 40px;\n\n    &_content {\n      bottom: 40px;\n    }\n  }\n}\n\n@media screen and (max-width: 1530px) {\n  .card-collection {\n    position: relative;\n    margin-bottom: 10px;\n    z-index: 1;\n\n    &-header,\n    &-content {\n      margin-left: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
